import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostProjektStatusCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostProjektStatusCommandService],
  exports: []
})
export class PostProjektStatusCommandServiceModule { }
